import React from 'react';
import { FileNode, OpenFile } from '../..//types/types';

interface TabBarProps {
  openFiles: Map<string, OpenFile>;
  fileSystem: Map<string, FileNode>;
  activeFileId: string | null;
  onTabClick: (id: string) => void;
  onTabClose: (id: string) => void;
}

const TabBar: React.FC<TabBarProps> = ({ openFiles, fileSystem, activeFileId, onTabClick, onTabClose }) => {
  return (
    <div className="tab-bar">
      {Array.from(openFiles.entries()).map(([id, openFile]) => {
        const file = fileSystem.get(id);
        if (!file) return null;

        const isActive = activeFileId === id;
        const isModified = openFile.modified;

        return (
          <div
            key={id}
            className={`tab ${isActive ? 'active' : ''} ${isModified ? 'modified' : ''}`}
            onClick={() => onTabClick(id)}
          >
            <span className="tab-label">{file.name}</span>
            <button
              className="tab-close"
              onClick={e => {
                e.stopPropagation();
                onTabClose(id);
              }}
            >
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default TabBar;
